import createLucideIcon from '../createLucideIcon';

const Network = createLucideIcon('Network', [
  ['rect', { width: '6', height: '6', x: '9', y: '2', key: '11q9i4' }],
  ['rect', { width: '6', height: '6', x: '16', y: '16', key: '11r92f' }],
  ['rect', { width: '6', height: '6', x: '2', y: '16', key: 'rycdd4' }],
  ['path', { d: 'M5 16v-4h14v4', key: '8njgxx' }],
  ['path', { d: 'M12 12V8', key: '2874zd' }],
]);

export default Network;
